import { render, staticRenderFns } from "./BAutocompleteBaseEvent.vue?vue&type=template&id=ec8455b2&"
import script from "./BAutocompleteBaseEvent.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteBaseEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports